import React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { formatDateWithoutTime, numberWithComma } from 'helpers/format'
import { TableListPage } from 'Components/common/Table'
import { PriceData } from 'Store/minirmx-dashboard/types'
import { themeConfig } from 'config'

type Props = {
  datas: PriceData[]
} & ReduxProps

const PricingReport: React.FunctionComponent<Props> = props => {
  const { datas } = props
  const columns = [
    {
      title: '',
      dataIndex: 'txt',
      key: 'txt',
      align: 'left',
    },
    {
      title: 'ราคาขายสูงที่สุด',
      dataIndex: 'max_price',
      key: 'max_price',
      align: 'center',
      render: (val: number) => numberWithComma(val || 0),
    },
    {
      title: 'ราคาขายต่ำที่สุด',
      dataIndex: 'min_price',
      key: 'min_price',
      align: 'center',
      render: (val: number) => numberWithComma(val || 0),
    },
    {
      title: 'ราคาขายพบบ่อยที่สุด',
      dataIndex: 'freq_price',
      key: 'freq_price',
      align: 'center',
      render: (val: number) => numberWithComma(val || 0),
    },
  ]

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Row gutter={[16, 16]} justify="space-between" align="middle">
          <Col>
            <BoxTitle>รายงานขายคอนกรีตแต่ละประเภท (บาท)</BoxTitle>
          </Col>
        </Row>
      </Col>
      <Col md={24} xs={24} sm={24}>
        <BoxWrapper>
          <Row gutter={[16, 16]} align="top" justify="center">
            <Col span={24}>
              <TableListPage
                columns={columns}
                datas={datas}
                isLoading={false}
                paginationContent={null}
                size="small"
                bordered={false}
                rowKey="txt"
                scrollX={400}
              />
            </Col>
            <Col span={24}>
              <Unit>{`ข้อมูลราคาขายมาจาก ${
                themeConfig.title.terminalName
              } และ ${themeConfig.title.appName.toUpperCase()} Application เท่านั้น`}</Unit>
            </Col>
          </Row>
        </BoxWrapper>
      </Col>
    </Row>
  )
}

const BoxWrapper = styled.div`
  padding: 0px 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border-radius: 10px;
  border-color: transparent;
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const Unit = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  margin-bottom: 10px;
`

const mapStateToProps = (state: RootState) => {
  return {}
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PricingReport)
